export const COMMUNITY_NEW_CHANNEL_CREATION = true;
export const NAVIGATION_ACTIONS_DISABLED = true;
export const HIDE_COMMUNITY_INBOX = true;
